import { useState, useCallback } from 'react';

export const useAlert = () => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    type: 'info',
    title: '',
    message: '',
    onConfirm: null,
    confirmText: 'OK',
    showCancel: false,
    cancelText: 'Cancel',
    onCancel: null,
  });

  const showAlert = useCallback(({
    type = 'info',
    title = '',
    message = '',
    onConfirm = null,
    confirmText = 'OK',
    showCancel = false,
    cancelText = 'Cancel',
    onCancel = null,
  }) => {
    setAlertState({
      isOpen: true,
      type,
      title,
      message,
      onConfirm: () => {
        if (onConfirm) onConfirm();
        setAlertState(prev => ({ ...prev, isOpen: false }));
      },
      confirmText,
      showCancel,
      cancelText,
      onCancel: () => {
        if (onCancel) onCancel();
        setAlertState(prev => ({ ...prev, isOpen: false }));
      },
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertState(prev => ({ ...prev, isOpen: false }));
  }, []);

  return {
    alertState,
    showAlert,
    hideAlert,
  };
};

export default useAlert;
